import React, {
  useMemo,
} from 'react'

import ToasterContext from './ToasterContext'
import useToasterContext from './Toaster.logic/useToasterContext'
import MyToasters from './Toaster.components/MyToasters'

const ToasterProvider = ({ children }) => {
  // console.log('ToasterProvider.js')
  const toasterContextData = useToasterContext()

  return useMemo(() => (
    <ToasterContext.Provider value={toasterContextData}>
      <MyToasters toasts={toasterContextData.toasts} />
      { children }
    </ToasterContext.Provider>
  ), [toasterContextData])
}

export default ToasterProvider
